import React from 'react';

import styled from 'styled-components';

import {StickyDocumentMenuButton} from 'app/components/general/DetailPage/RightSidebar/StickyDocumentSidebar';
import {getDeltaBasedOnOrder} from 'app/components/general/DetailPage/RightSidebar/utils';
import {mediaBreakpoints} from 'app/general/mediaqueries';

import type {LeftSidebarElementType} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {StickySidebarElementType} from 'app/components/general/DetailPage/RightSidebar/structure/types';
import type {
  CurrentItemType,
  CurrentVersionType,
  DetailPageItemType,
  RouteType,
} from 'app/components/general/DetailPage/types';
import type {WidgetIsOpenPayloadType} from 'app/settings/slice';

type Props<ItemType extends DetailPageItemType> = {
  object: CurrentItemType<ItemType>;
  version: CurrentVersionType<ItemType>;
  rightSidebarPanels: Array<StickySidebarElementType<ItemType>>;
  fullscreenWidgetName:
    | undefined
    | WidgetIsOpenPayloadType['widgetName']
    | RouteType<ItemType>;
  setFullscreenWidget: (
    widget:
      | null
      | StickySidebarElementType<DetailPageItemType>
      | LeftSidebarElementType<DetailPageItemType>
  ) => void;
};

export function RightSidebar<ItemType extends DetailPageItemType>({
  object,
  version,
  rightSidebarPanels,
  fullscreenWidgetName,
  setFullscreenWidget,
}: Props<ItemType>) {
  return (
    <RightSidebarBaseStructure className="border-left border-top d-flex h-100 bg-white shadow-sm">
      {fullscreenWidgetName != null && (
        <StickyDocumentMenuButton
          object={object}
          buttonDelta={getDeltaBasedOnOrder(-1, rightSidebarPanels.length)}
          setFullscreenState={() => {
            setFullscreenWidget(null);
          }}
        />
      )}

      {rightSidebarPanels.map(({MenuButton}, index) => (
        <MenuButton
          key={`sidebar-component-menu-${index}`}
          object={object}
          buttonDelta={getDeltaBasedOnOrder(index, rightSidebarPanels.length)}
        />
      ))}
      {rightSidebarPanels.map((Sidebar, index) => {
        if (Sidebar.sidebarName === fullscreenWidgetName) {
          return null;
        }
        return (
          <Sidebar.Panel
            key={`sidebar-component-panel-${index}`}
            object={object}
            version={version}
            setFullscreenState={(isFullscreen: boolean) => {
              setFullscreenWidget(isFullscreen ? Sidebar : null);
            }}
          />
        );
      })}
    </RightSidebarBaseStructure>
  );
}

const RightSidebarBaseStructure = styled.div`
  max-width: ${mediaBreakpoints.sm + 'px'};
`;
